module.exports = __webpack_public_path__ + "img/02-02-img-01@2x.c2d587a1.png";